
import api from '../../../../../common/dependencies/utils/Api';
import {VIEW_APPLICATION_DATA, UPDATE_APPLICATION_STATUS,VIEW_MENTOR_APPLICATION_DATA,VIEW_COHORT_APPLICATION_DATA
} from "../../../../../common/constants/ApplicationUrl";

export const AdminMentorViewServices = {
    getViewApplicationCohort(params) {
        
        return api.POST(`${VIEW_COHORT_APPLICATION_DATA}`, params)
        .then((response) => {
            const { data, status } = response || {};
            if (status === 200) {
              return response.data ;
          } else {
              return { status: false }
          }
           
        }).catch(e => {
            return Promise.reject(e);
        })
    },
 
    getViewApplicationData(params,fromModule) {
        // let url= fromModule
        return api.POST(`${fromModule==="mentorList"? VIEW_MENTOR_APPLICATION_DATA:VIEW_APPLICATION_DATA}`, params)
        .then((response) => {
            const { data, status } = response || {};
            if (status === 200) {
              return response.data ;
          } else {
              return { status: false }
          }
           
        }).catch(e => {
            return Promise.reject(e);
        })
    },
    updateApplicationStatus(params) {
        return api.POST(`${UPDATE_APPLICATION_STATUS}`, params)
        .then((response) => {
            const { data, status } = response || {};
            if (status === 200) {
              return response.data ;
          } else {
              return { status: false }
          }
           
        }).catch(e => {
            return Promise.reject(e);
        })
    }
    
    

}